export default "__VITE_ASSET__ebc10a5f__"